import React from "react";
import { Col } from "antd";
import RenderComponent from "components/renderComponent";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

type INewRegisterButton = {
  isConcierge: boolean;
  lobbyShowDrawerInbound: () => void;
};

export const NewRegisterButton = ({ isConcierge, lobbyShowDrawerInbound }: INewRegisterButton): JSX.Element => (
  <RenderComponent isRender={isConcierge}>
    <Col flex="220px" style={S.AddButtonCol}>
      <S.AddButton onClick={lobbyShowDrawerInbound}>{useTranslation({ id: "new_entry" })}</S.AddButton>
    </Col>
  </RenderComponent>
);
